import { useEffect } from 'react'

interface UseWindowResizeHandlerProps {
  isMobileDevice: boolean
  lockSideBarOpened: boolean
  setLockSideBarOpened: () => void
  setSidebarIsOpen: (open: boolean) => void
}

export function useWindowResizeHandler({
  isMobileDevice,
  lockSideBarOpened,
  setLockSideBarOpened,
  setSidebarIsOpen,
}: UseWindowResizeHandlerProps) {
  useEffect(() => {
    if (!isMobileDevice) {
      const handleWidthChange = () => {
        if (window.innerWidth < 1240) {
          lockSideBarOpened && setLockSideBarOpened()

          setSidebarIsOpen(false)
        }
      }

      handleWidthChange()

      window.addEventListener('resize', handleWidthChange)

      return () => {
        window.removeEventListener('resize', handleWidthChange)
      }
    }
  }, [
    isMobileDevice,
    lockSideBarOpened,
    setLockSideBarOpened,
    setSidebarIsOpen,
  ])
}
